module.exports = __webpack_public_path__ + "app/assets/img/gafam/edge-internet-explorer.png";